export default {
	DEFAULT: 'DEFAULT',
	PUBLIC: 'PUBLIC',
	PRIVATE: 'PRIVATE'
};
